import styled from "@emotion/styled"

const Input = styled("input")`
	border: 0;
	padding: 1rem;
	font-size: 16px;
	display: block;
	width: 100%;
  border: 1px solid #111;
  letter-spacing: 0;
  font-weight: 300;
`
const TextArea = styled("textarea")`
	border: 0;
	padding: 1rem;
	font-size: 16px;
	display: block;
	width: 100%;
	height: 100%;
	resize: none;
  border: 1px solid #111;
  letter-spacing: 0;
  font-weight: 300;
`

const Select = styled("select")`
	border: 0;
	padding: 1rem;
	font-size: 16px;
	display: block;
	width: 100%;
  border: 1px solid #111;
  letter-spacing: 0;
  font-weight: 300;
  background-color: white;
  cursor: pointer;
  
  &:focus {
    outline: none;
  }
`

export { Input, TextArea, Select }
